import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Grid } from '@mui/material';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import english from '../../assets/lang/english';
import { CustomerData, DeleteCustomer } from './utils/TypeCustomer';
import DataTable from '../../Common/DataTable';
import { TableColumns } from './utils/DataCustomerHeaderCell';
import EndPoints from '../../Routes/EndPoints';
import { deleteCustomerStart, getCustomersStart } from './redux/customerSlice';
import { RootState } from '../../redux/rootState';
import ComponentDeleteModal from '../../Common/DeleteModal/ComponentDeleteModal';
// import { removeSelectedCustomer } from '../addCustomer/redux/addCustomerSlice';
import { setLoader } from '../../redux/loaderSlice';
import {
  resetPaginationCust, setPageNumberCust, setPageSizeCust, setSearchParamCust,
} from '../taiReportingSystem/redux/sliceReportWorkspace';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { removeSelectedCustomer } from '../addCustomer/redux/addCustomerSlice';
import { stripCustPrefix } from '../../utils/CommonFunctions';

export default function ScreenCustomerDetail() {
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchQuery, setSearchQuery] = useState('');
  const {
    pageNumberCust, pageSizeCust, searchParamCust,
  } = useSelector((state: RootState) => state.reportWorkspaceReducer);
  const { customers, totalEntries, isLoading } = useSelector((state: RootState) => state.customerReducer);
  const { showDeleteIcon, historyStack } = useSelector((state: RootState) => state.masterDataReducer);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [selectedCustId, setSelectedCustId] = useState('');
  const dispatch = useDispatch();

  const handleButtonClick = () => {
    // Cleaning addCustomerSlice States
    dispatch(removeSelectedCustomer());
    navigate(EndPoints.ADD_CUSTOMER);
  };

  const handleData = () => {
    const payload = {
      page: pageNumberCust,
      rowsPerPage: pageSizeCust,
      searchQuery: searchParamCust,
    };
    dispatch(getCustomersStart(payload));
  };

  useEffect(() => {
    handleData();
  }, [pageNumberCust, pageSizeCust, searchParamCust]);

  // useEffect(() => {
  //   handleData();
  // }, []);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const handleDelete = (customerId: string) => {
    setDeleteModal(true);
    setSelectedId(customerId);
  };

  const handleDeleteModal = () => {
    const payload: DeleteCustomer = {
      customerId: selectedId,
      page: pageNumberCust,
      rowsPerPage: pageSizeCust,
      searchQuery: searchParamCust,
    };
    dispatch(deleteCustomerStart(payload));
    setDeleteModal(false);
  };

  const data: CustomerData[] = useMemo(() => customers.map((item, index) => {
    const transformedDataItem = {
      markUp: item?.Markup,
      cust: stripCustPrefix(item?.Custid),
      company: item?.Customername,
      address: item?.Address,
      city: item?.CityName,
      state: item?.StateName,
      phone: item?.Phone,
      smc: item?.SmcName,
      action: showDeleteIcon ? 'edit&delete' : 'edit',
      sn: index,
      id: item?.Custid,
    };
    return transformedDataItem;
  }), [customers]);

  const excelData = useMemo(() => customers.map((item) => {
    const transformedDataItem = {
      markUp: item?.Markup,
      cust: stripCustPrefix(item?.Custid),
      company: item?.Customername,
      address: item?.Address,
      city: item?.CityName,
      state: item?.StateName,
      phone: item?.Phone,
      smc: item?.SmcName,
    };
    return transformedDataItem;
  }), [customers]);

  const handleEdit = (customerId: string) => {
    navigate(`${customerId}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'Customer_list',
    );
  };

  const openJobPage = () => {
    navigate(`${EndPoints.ADD_JOB_WITH_ID}/${selectedCustId}`);
  };

  useEffect(() => {
    if (historyStack) {
      const finderString = '/customers/';
      const last = historyStack[historyStack.length - 1];
      const sLast = historyStack[historyStack.length - 2];
      if (!(
        last?.includes(finderString)
        || (sLast?.includes(finderString) && last?.includes('/customers'))
        || last?.includes('/jobs/')
        || (sLast?.includes('/jobs/') && last?.includes('/customers'))
        || last?.includes('/unit/')
        || (sLast?.includes('/unit/') && last?.includes('/customers'))
        || last?.includes('/job-order/')
        || (sLast?.includes('/job-order/') && last?.includes('/customers'))
        || last?.includes('/test-request/')
        || (sLast?.includes('/test-request/') && last?.includes('/customers'))
        || last?.includes('/add-unit/')
        || (sLast?.includes('/add-unit/') && last?.includes('/customers'))
      )) {
        dispatch(resetPaginationCust());
      }
    }
  }, [historyStack]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <ComponentPageHeader subHeading={String(english.Customer)} downloadExcel={downloadExcel} />
        </Grid>
        <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
          <div className="customTableWidth">
            <DataTable<CustomerData>
              handleButtonClick={handleButtonClick}
              data={data}
              columns={TableColumns}
              totalRecords={totalEntries}
              buttonText="Add New Customer"
              searchButton="Add New Job"
              searchButtonDisable={selectedCustId === ''}
              handleSearchButtonClick={openJobPage}
              page={pageNumberCust}
              setPage={(e) => { dispatch(setPageNumberCust(e)); }}
              rowsPerPage={pageSizeCust}
              setRowsPerPage={(e) => { dispatch(setPageSizeCust(e)); }}
              searchQuery={searchParamCust}
              setSearchQuery={(e) => { dispatch(setSearchParamCust(e)); dispatch(setPageNumberCust(1)); }}
              handleData={handleData}
              handleDelete={handleDelete}
              handleEdit={handleEdit}
              radioButtonColumnsWithKey={['sn']}
              selectedRadioWithKey={selectedCustId}
              setSelectedRadioWithKey={setSelectedCustId}
              handleDataFromComponent
            />
          </div>
        </Grid>
      </Grid>
      <ComponentDeleteModal
        show={showDeleteModal}
        setOpenFrom={() => setDeleteModal(false)}
        handleDelete={handleDeleteModal}
      />

    </>
  );
}
